export function filterQuotes(ctrl, index, model, noneModel, val, limit, currentLimit, moreQuotes) {
    if (model === noneModel && !moreQuotes) {
        ctrl[currentLimit] = limit;
    }
    if (index < ctrl[currentLimit]) {
        if (angular.equals(model, val) && !moreQuotes) {
            ctrl[currentLimit] = limit;
        }
        return true;
    }
    if (angular.equals(model, val)) {
        ctrl[currentLimit] = limit - 1;
        return true;
    }
    return false;
}
